// Multi-Room Editing Drawer
// User ctrl-clicks to add rooms to multiSelectRoomArray ("mouse-up" on esri-map.vue)
// It will not show unless user is a manager of at least one dept.
// An array of roomKeys ("300A+A316") is sent along with an object describing properties to change
// All rooms in array are updated with any properties that are not NULL.  NULL properties are ignored.
// multiSelectRoomArray is cleared on empty map click.

<template>
	<LeftSidebar v-if="isSpaceManager" :open="showDVBulkEdit" :width="650" :updateSidebar="setShowDVBulkEdit"
		:right="true"
		:class="{ 'white' : !darkTheme, 'grey darken-2' : darkTheme }" 
		:lowerTitle="true"
		style="z-index: 32 !important">
		
		<div slot="sbTitle" >
			Bulk Room Editor
    	</div> 

    	<div slot="sbContent" class="caption pt-4">
    		<BulkRoomEditSideBarContent :dv="true" v-on:refresh="refreshRooms" />
    	</div>	    
	</LeftSidebar>
</template>

<script>

import { mapMutations, mapState } from 'vuex'
import LeftSidebar from '@/components/LeftSidebar'
import BulkRoomEditSideBarContent from '@/components/BulkRoomEditSideBarContent'

export default {

	data() {
  		return {}
	},

	components : { LeftSidebar, BulkRoomEditSideBarContent },

	computed: {

		...mapState({
			showDVBulkEdit: state => state.dv.showDVBulkEdit,
			darkTheme: state => state.ui.darkTheme,
			userManagedDepts: state => state.user.userManagedDepts,
		}),

	    isSpaceManager: function () {
			if (this.userManagedDepts.length > 0) {	return true	}
		},

	},

	methods: {
	  	...mapMutations([	'setShowDVBulkEdit', 	  						]),

		refreshRooms() {
			this.$emit('refresh')
		},
	}						
}

</script>


<style>
</style>





// WEBPACK FOOTER //
// src/components/RoomViewer/BulkRoomEditSideBarDV.vue